export default {
  //loading: 'Cargando…',
  error_bad_request: "Entrada invalida.",
  error_not_found: "Elemento no encontrado.",
  error_fetch: "La solicitud no pudo llegar a su destinación. Por favor verifique su conexión o intente más tarde.",
  error_server: "Error inesperado del sistema. Por favor intente más tarde.",

  // Home
  rafting: "Raft y mini-raft",
  canoraft: "Air boat",
  hydrospeed: "Hidrospeed",
  pricing: "Precios",
  more: "Infos",
  contact: "Contacto",
  title: "Rafting en Saint-Lary (65)",
  description:
    "¡Rafting es una actividad para descubrir las aguas bravas y el medio ambiente! Baja el río de una manera fácil y divertida. ¡Es una actividad acuática fácil en plena naturaleza!",
  subtitle:
    "Cuidado! Si reservas, eres el único responsable de los efectos secundarios que la sobredosis de felicidad inusual podría resultar en tu vida!",
  cta: "Reservar",
  rafting_description:
    "Ven a descubrir una actividad que la montaña nos da, divertida, acuática y rodeados de naturaleza. De 1h 30 a 1h 45 de recorrido tendremos aventuras a bordo de un gran bote inflable que nos cambiará el escenario! Gran idea para compartir una gran experiencia de rafting entre familia y amigos en una de las arterias del valle, la hermosa Neste d'Aure.",
  canoraft_description:
    "En parejas o solos, estos pequeños botes inflables similares a los rafts, también llamados canoraft o hot-dog, te permitirán una aproximación más independiente y dinámica al mismo recorrido, con una pequeña sorpresa a mitad. No recomendado para parejas frágiles 😜",
  hydrospeed_description:
    "También conocida como natación en aguas bravas, las aletas y esta embarcación de gran maniobrabilidad, creada originalmente para el salvamento en aguas bravas, ofrecen un enfoque diferente del río. Más físico que las embarcaciones neumáticas, el hidrospeed permite comprender mejor los movimientos y las corrientes del agua, ¡y todo ello en inmersión total! Para sacarle el máximo partido, te aconsejamos que ya hayas utilizado aletas y que tengas al menos 14 años.",
  duration: "Duración total: {duration}",
  departures: "Cita a las 9:30 o 14:30",
  price: "Precio: {price, number, money}",
  what_to_bring: "Material necesario: Traje de baño y zapatos cerrados. Todo lo demás va por nuestra cuenta!",
  what_to_bring_light: "Material necesario: Traje de baño. Todo lo demás va por nuestra cuenta!",
  more_gear:
    "Aparte del calzado y la ropa de baño, todo el equipo necesario para las actividades está incluido, al igual que el traslado en minibús de vuelta a la base.",
  more_infos: "Todo el equipo esta limpiado después de cada bajada",
  instructor:
    "Para combinar placer con seguridad, tus instructores: Jean y Charlie, certificados BPJEPS canoa y kayac. Han estado navegando en la Neste d'Aure por más de 10 años. También son socorristas en la estación de esquí de Piau-Engaly.",
  legal: "Avisos legales y condiciones generales de venta",
  guides: "Jean y Charlie",

  // Calendar
  calendar_title: "Escoje tu fecha…",
  weekday1: "Lunes",
  weekday2: "Martes",
  weekday3: "Miércoles",
  weekday4: "Jueves",
  weekday5: "Viernes",
  weekday6: "Sábado",
  weekday7: "Domingo",
  morning: "Mañana",
  afternoon: "Tarde",
  spots: "{num, plural, one {Un lugar} other {# lugares}}",
  full: "lleno",
  closed: "descanso",
  after_season: "La temporada se acabó. Hasta el próximo año!",

  // Book
  book_title: "Confirma tu reservación…",
  tomorrow_alert: "Reserva antes de las 9 de la noche para pasear mañana!",
  total: "Total {amount, number, money}",
  deposit: "Paga ahora {amount, number, money} ({percent}% de depósito)",
  remaining: "A pagar en el lugar: {amount, number, money}",
  discount: "Haz clic aquí si tienes un código de promoción",
  discount_placeholder: "Código de promoción…",
  discount_checking: "Verificando…",
  discount_percent: "Incluyendo tu descuento de {discount}%!",
  checkout_title: "Reserva para {people, plural, one {una persona} other {# personas}}",
  checkout_description: "El {date, date, event} {type, select, morning {en la mañana} afternoon {en la tarde}}",
  checkout_label: "Pagar", // X €
  checkout_button: "Pagar",
  paying: "Reservando…",
  error_too_late: "Ups, es muy tarde para reservar mañana.",
  error_missing_spots: "Ups, no hay suficientes lugares disponibles para ese día.",
  error_full: "Ups, ese día esta lleno.",
  error_closed: "Ups, estamos descansando ese día.",
  error_code_not_found: "Este código no existe o ya no es válido.",
  unavailable_combination: "Ups, esta combinación no está disponible. Intenta elegir otro horario o actividad.",

  // Thanks
  thanks_title: "Listo!",
  thanks:
    "Gracias por tu reservación. Una confirmación ha sido enviada a tu correo electrónico con toda la información.",

  // Forms
  form_name: "Nombre completo",
  form_email: "Correo electrónico",
  form_message: "Escribe tu mensaje",
  form_phone: "Número telefónico",
  form_people: "Cuántas personas",
  option_type: "{type, select, morning {Por la mañana} afternoon {Por la tarde}}",
  activities: "Actividad:",
  option_activity:
    "{activity, select, rafting {Rafting} canoraft {Canoraft (airboat)} hydrospeed {Hidrospeed (natación en aguas bravas)}}",
  option_activity_max: "{max, plural, one {1 lugar} other {# lugares}}",
  form_confirm: "Garantizo que todos sabemos nadar",
  form_referral: "¿Cómo nos encontraste?",
  incomplete_form: "Por favor llena todos los espacios para completar la reservación.",
  send: "Enviar",
  sent: "Tu mensaje ha sido enviado. Recibirás una respuesta muy pronto.",
  unavailable: "Indisponible",
}
